import GameContext from "./GameContext"
import { useState ,useEffect} from "react";

const GameState = (props) => {

    const [isRunning, setIsRunning] = useState(false);
  const host = "https://sudoku-backend.netlify.app/.netlify/functions"
  const [elementRemoved, setelementRemoved] = useState(0)
  const GameInitial = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
  ]
  const [originalData, setoriginalData] = useState([
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
  ])
  //Fetch note
  const getGame = async (k) => {
    //api
    const response = await fetch(`${host}/api/game/findgame`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const json = await response.json();
    localStorage.setItem('gameid',json._id)
    setoriginalData(JSON.parse(JSON.stringify(json)).game)
    setelementRemoved(k)
    remove(json,k)
  }
  const [GameR, setGameR] = useState(GameInitial);
  const remove = (json,k) => {
    let count = k
    while (count !== 0) {
      let cellId = Math.floor(Math.random() * 80 + 1)
      let i = parseInt(cellId / 9);
      let j = cellId % 9;
      if (json.game[i][j] !== 0) {
        count--;
        json.game[i][j] = 0
      }
    }
    setGameR(json.game)
  }
  const addDashboardEntry = async (userid,name,game,level,time) => {
    //api
    const entry={"game":game, "level":level, "time":time}
    console.log(entry)
    const response = await fetch(`${host}/api/dashboard/addentry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },
      body: JSON.stringify({userid,name,game,level,time})
    });
    const json= await response.json()
  }
  const getuser = async () => {

      if (localStorage.getItem('token')) {
          const response = await fetch(`${host}/api/auth/getuser`, {
              method: 'POST',
              headers: {
                  'auth-token': localStorage.getItem('token')
              },
          });
          const json = await response.json()
          localStorage.setItem('userid', json._id)
          localStorage.setItem('username',json.name)
          localStorage.setItem('email', json.email)
      }
  }
  const getDashboardEntry = async (setdashboardEntry) => {
          const response = await fetch(`${host}/api/dashboard/fetchallentry`, {
              method: 'GET',
              headers: {
              },
          });
          const json = await response.json()
          setdashboardEntry(json)
      }
  return (
    <GameContext.Provider value={{ getGame,originalData,GameR,elementRemoved,addDashboardEntry,getuser,getDashboardEntry,isRunning,setIsRunning}}>
      {props.children}
    </GameContext.Provider>
  )
}
export default GameState